import React, { useState, useEffect, ReactNode } from 'react';
import { navigate } from 'gatsby';
import { Waypoint } from 'react-waypoint';
import { useLocation } from '@gatsbyjs/reach-router';
import IsiHeader from './header';
import IsiBody from './body';
import classnames from 'classnames';
import IsiContainer from './container';

const Isi: React.FC<{ children: ReactNode }> = ({ children }) => {
	const location = useLocation();
	const [sticky, setSticky] = useState(true);
	const [bottomGap, setBottomGap] = useState(true);
	const [toggled, setToggled] = useState(false);

	const handleToggle = () => {
		if (!toggled) {
			setSticky(false);
			navigate('#importantsafetyinformation', { replace: true });
			setToggled(true);
		} else {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
			setToggled(false);
		}
	};

	// Updates the toggle to prevent issues when moving from long->short pages
	useEffect(() => {
		if (window.scrollY === 0 && toggled) {
			setToggled(false);
		}
	}, [location.pathname]);

	return (
		<>
			<Waypoint
				onEnter={({ previousPosition }) => {
					if (previousPosition === Waypoint.above) {
						setSticky(true);
						setBottomGap(true);
						setToggled(false);
					}
				}}
				onLeave={({ currentPosition }) => {
					if (currentPosition === Waypoint.above) {
						setBottomGap(false);
						setSticky(false);
						setToggled(true);
					}
				}}
				topOffset="80%"
			/>
			<Waypoint
				onEnter={({ previousPosition }) => {
					// previousPosition undefined means the element was
					// rendered directly within the viewport
					if (previousPosition === undefined) {
						setBottomGap(false);
						setSticky(false);
					} else if (previousPosition === Waypoint.above) {
						setToggled(false);
					}
				}}
				onLeave={({ currentPosition }) => {
					if (currentPosition === Waypoint.above) {
						setToggled(true);
					}
				}}
				topOffset="20%"
				bottomOffset="20%">
				<div
					id="importantsafetyinformation"
					className={bottomGap ? 'h-[23vh]' : ''}
				/>
			</Waypoint>
			<div id="isi"
				className={classnames('w-full z-50', {
					'fixed top-[80%]': sticky,
				})}>
				<IsiContainer>
					<IsiHeader toggled={toggled} onClick={() => handleToggle()} />
					<IsiBody />
					{children}
				</IsiContainer>
			</div>
		</>
	);
};
export default Isi;
